// src/store/modules/landing-page.js
import { GET_CONFIG, GET_MEMBERGROUPS, GET_MEMBERSLIST, GET_CONTACT_PERSON, UPDATE_MEMBERGROUP, UPDATE_CONTACTPERSON, UPDATE_BANKDATA, UPDATE_STATUS_MEMBERGROUP,  UPDATE_MEMBERS, CREATE_MEMBERGROUP, CREATE_MEMBER, GET_MEMBERCOUNT } from '@/store/action-types';
import { SET_CONFIG, SET_MEMBERGROUPS, SET_MEMBERGROUP, SET_MEMBERSLIST, SET_CONTACT_PERSON, SET_BANKDATA, SET_MEMBERS, SET_MEMBERCOUNT } from '@/store/mutation-types';
import { GET_BANKDATA, GET_MEMBERGROUP, GET_MEMBERS } from '@/store/getters-types';
import memberModel from '@/models/member'; 
import memberGroupModel from '@/models/membergroup';
import contactPersonModel from '@/models/contactperson';
import bankdataModel from '@/models/bankdata';

export default {
  namespaced: true,
  actions: {

    async [GET_MEMBERGROUPS]({ commit }) {
      commit(SET_MEMBERGROUPS, await memberGroupModel.getAll());
    },
    
    async [GET_MEMBERCOUNT]({ commit }) {
      commit(SET_MEMBERCOUNT, await memberModel.getCount());
    },
    
    async [GET_MEMBERSLIST]({ commit }) {
      commit(SET_MEMBERSLIST, await memberModel.getAll());
    },
    async [GET_CONFIG]({ commit }) {
      commit(SET_CONFIG, await memberModel.getConfig());
    },
    async [UPDATE_CONTACTPERSON]({ commit }, {memberGroupId, contactPerson}) {
      let contactPersonOut = await contactPersonModel.update(contactPerson.id, contactPerson)
      commit(SET_CONTACT_PERSON, {'memberGroupId': memberGroupId, 'contactPerson': contactPersonOut})
    },
    async [UPDATE_BANKDATA]({ commit }, {memberGroupId, bankdata}) {
      let bankdataOut = await bankdataModel.update(bankdata.id, bankdata)
      commit(SET_BANKDATA, {'memberGroupId': memberGroupId, 'bankdata': bankdataOut})
    },
    // eslint-disable-next-line no-unused-vars
    async [UPDATE_MEMBERS]({ commit }, {memberGroupId, members}) {
      let outMembers = []
      for (const property in members) {
        let member = members[property]
        let out = await memberModel.update(member.id, member)
        outMembers.push(out);
      }
      commit(SET_MEMBERS, {'memberGroupId': memberGroupId, 'members': outMembers})
    },
    async [UPDATE_STATUS_MEMBERGROUP]({ commit }, {memberGroupId, url}) {
      await memberGroupModel.updateStatus(url)
      let memberGroupIdOut = await memberGroupModel.get(memberGroupId);
      commit(SET_MEMBERGROUP, {'memberGroupId': memberGroupId, 'memberGroup': memberGroupIdOut})
    },
    async [UPDATE_MEMBERGROUP]({ commit }, {memberGroupId, memberGroup}) {
      let memberGroupIdOut = await memberGroupModel.update(memberGroupId, memberGroup)
      commit(SET_MEMBERGROUP, {'memberGroupId': memberGroupId, 'memberGroup': memberGroupIdOut})
    },
    async [CREATE_MEMBERGROUP]({ commit }) {
      let memberGroup = {
        "bankdata": {
          "accountowner": "Max Mustermann",
          "address": {
            "city": "Musterstadt",
            "id": 0,
            "postalcode": 12345,
            "street": "Maxmustermannstr."
          },
          "date": "2020-01-01",
          "iban": "DE12312312313",
          "id": 0,
          "location": "Musterstadt"
        },
        "comment": "string",
        "contactPerson": {
          "city": "Musterstadt",
          "email": "max@mustermann.de",
          "firstname": "Max",
          "id": 0,
          "lastname": "Mustermann",
          "postalcode": 12345,
          "street": "Maxmustermannstr.",
          "telephone": "0123-456789"
        },
        "family": true,
        "id": 0,
        "members": [
          {
            "birthday": "1986-04-14",
            "club": "NONE",
            "email": "max@mustermann.de",
            "firstname": "Max",
            "id": 0,
            "lastname": "Mustermann",
            "memberType": "EV",
            "telephone": "0123-456789"
          }
        ],
        "status": "REGISTERED"
      }
      let memberGroupOut = await memberGroupModel.create(memberGroup)
      commit(SET_MEMBERGROUP, {'memberGroupId': memberGroupOut.id, 'memberGroup': memberGroupOut})
    },
    async [CREATE_MEMBER]({ commit }, {memberGroupId}) {
      let member = {
            "birthday": "1986-04-14",
            "club": "NONE",
            "email": "max@mustermann.de",
            "firstname": "Max",
            "id": 0,
            "lastname": "Mustermann",
            "memberType": "EV",
            "telephone": "0123-456789"
      }
      let memberGroupOut = await memberGroupModel.createMember(memberGroupId, member)
      commit(SET_MEMBERGROUP, {'memberGroupId': memberGroupOut.id, 'memberGroup': memberGroupOut})
    },
  },
  mutations: {
    [SET_MEMBERGROUPS](state, event) {
      let tempMap = new Map()
      event.forEach(element => {
        tempMap.set(element.id, element);
      });
      state.membergrouplist = tempMap
    },
    [SET_MEMBERSLIST](state, event) {
      let tempMap = new Map()
      event.forEach(element => {
        tempMap.set(element.id, element);
      });
      state.memberlist = tempMap
    },
    [SET_MEMBERGROUP](state, {memberGroupId, memberGroup}) {
      let memberGroupOld = state.membergrouplist.get(memberGroupId);
      memberGroupOld = Object.assign({}, memberGroupOld, memberGroup)
      let memberGroupList = state.membergrouplist;
      memberGroupList.set(memberGroupId, memberGroupOld);
      state.membrgrouplist = memberGroupList
    },
    [SET_CONTACT_PERSON](state, {memberGroupId, contactPerson }) {
      let memberGroup = state.membergrouplist.get(memberGroupId);
      memberGroup.contactPerson = contactPerson
      state.membergrouplist.set(memberGroupId, memberGroup);
    },
    [SET_BANKDATA](state, {memberGroupId, bankdata }) {
      let memberGroup = state.membergrouplist.get(memberGroupId);
      memberGroup.bankdata = bankdata
      state.membergrouplist.set(memberGroupId, memberGroup);
    },
    [SET_MEMBERS](state, {memberGroupId, members }) {
      let memberGroup = state.membergrouplist.get(memberGroupId);
      memberGroup.members = members
      state.membergrouplist.set(memberGroupId, memberGroup);
    },
    [SET_CONFIG](state, event) {
      state.config = event.data
    },
    [SET_MEMBERCOUNT](state, event) {
      state.count = event.data
    },
  },
  getters: {
    // ...
    [GET_CONTACT_PERSON]: (state) => (memberGroupId) => {
      let out = state.membergrouplist.get(memberGroupId);
      return out.contactPerson;
    },
    [GET_MEMBERGROUP]: (state) => (memberGroupId) => {
      let out = state.membergrouplist.get(memberGroupId);
      return out;
    },
    [GET_BANKDATA]: (state) => (memberGroupId) => {
      let out = state.membergrouplist.get(memberGroupId);
      return out.bankdata;
    },
    [GET_MEMBERS]: (state) => (memberGroupId) => {
      let out = state.membergrouplist.get(memberGroupId);
      return out.members;
    },
  },
  // We initialize the state with
  // an empty LandingPage object.
  state: {
    membergrouplist: new Map(),
    config: {},
    memberlist: new Map(),
    count: '-'
  },
};